<template>
  <div class="w-full h-full">
    <div class="w-full h-full flex flex-wrap mt-5">
      <div
        class="
          releative
          border
          w-full
          lg:w-3/4
          mx-3
          lg:mx-auto
          mt-8
          border-formBorderColor
          rounded-md
          p-5
          flex flex-wrap
        "
      >
        <span class="absolute -mt-8 bg-white text-primary text-lg font-bold">
          المعلومات الشخصية
        </span>
        <div class="w-full m-5">
          <input
            type="file"
            class="hidden"
            ref="uploadImg"
            accept="image/*"
            @change="OnPickerChange"
          />
          <div class="relative h-48 w-40">
            <i
              v-if="imageSrc"
              @click="
                imageSrc = null;
                form.doctor_image = null;
              "
              class="
                bx
                bxs-x-circle
                cursor-pointer
                rounded-full
                bg-white
                text-gray-500 text-3xl
                absolute
                left-0
                -mt-3
                -ml-2
              "
            ></i>
            <button
              @click.prevent="pickPicture"
              class="
                border-4 border-gray-500
                outline-none
                focus:outline-none
                border-dashed
                rounded-lg
                lg:rounded-md
                w-full
                h-full
                flex
                items-center
                justify-center
              "
            >
              <div v-if="!imageSrc && !form.doctor_image">
                <i class="bx bxs-user text-gray-500 text-4xl"></i>
                <h3 class="text-gray-500 text-sm mt-1">تحميل الصورة الشخصية</h3>
              </div>
              <img
                v-else
                alt=""
                loading="lazy"
                class="w-full h-full object-cover"
                :src="editDoctor ? 'https://' + form.doctor_image : imageSrc"
              />
            </button>
          </div>
        </div>
        <div
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="name"
            class="font-medium text-lg w-full text-right flex items-center"
            ><span class="text-red-600 mx-2 text-3xl mt-2">*</span>الاسم
            رُباعي</label
          >
          <input
            id="name"
            name="name"
            v-model="form.name"
            type="text"
            required
            @blur="$v.form.name.$touch()"
            :class="
              defualtInput +
              ($v.form.name.$error ? ' border-red-700' : 'border-inputBorder')
            "
          />
          <p
            v-if="$v.form.name.$error"
            class="text-red-600 text-sm my-1 w-full"
          >
            الرجاء تعبئة هذا الحقل
          </p>
        </div>
        <div
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="member_ship_id"
            class="font-medium text-lg w-full text-right flex items-center"
            >رقم العضوية</label
          >
          <input
            id="member_ship_id"
            name="member_ship_id"
            v-model="form.member_ship_id"
            type="text"
            required
            @blur="handleMemberShipIdBlur"
            :disabled="isHonoraryMembership"
            :class="
              defualtInput +
              (memeberShipExsistError
                ? ' border-red-700'
                : 'border-inputBorder')
            "
          />

          <label
            class="
              inline-flex
              justify-start
              items-center
              mx-2
              w-full
              text-right
            "
          >
            <input
              type="checkbox"
              class="form-checkbox"
              name="isHonoraryMembership"
              value="عضوية شرفية"
              v-model="isHonoraryMembership"
            />
            <span class="mr-2 text-h1Text">عضوية شرفية</span>
          </label>
          <p
            v-if="memeberShipExsistError"
            class="text-red-600 text-sm my-1 w-full"
          >
            {{ memeberShipExsistError }}
          </p>
        </div>
        <div
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="nationalities"
            class="font-medium text-lg w-full text-right flex items-center"
            ><span class="text-red-600 mx-2 text-3xl mt-2">*</span
            >الجنسية</label
          >
          <v-select
            :options="nationalities"
            dir="rtl"
            label="name"
            id="nationalities"
            :clearable="false"
            name="nationalities"
            v-model="form.nationality"
            :reduce="(nationality) => nationality.value"
            @blur="$v.form.nationality.$touch()"
            :class="
              defualtInput +
              ($v.form.nationality.$error
                ? ' border-red-700'
                : 'border-inputBorder')
            "
            class="p-0"
          ></v-select>
          <p
            v-if="$v.form.nationality.$error"
            class="text-red-600 text-sm my-1 w-full"
          >
            الرجاء تعبئة هذا الحقل
          </p>
        </div>
        <div
          v-if="form.nationality == 'Libyan'"
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="id_number"
            class="font-medium text-lg w-full text-right flex items-center"
            ><span class="text-red-600 mx-2 text-3xl mt-2">*</span>الرقم
            الوطني</label
          >
          <input
            id="id_number"
            name="id_number"
            v-model.number="form.id_number"
            type="text"
            required
            @blur="$v.form.id_number.$touch()"
            :class="
              defualtInput +
              ($v.form.id_number.$error
                ? ' border-red-700'
                : 'border-inputBorder')
            "
          />
          <p
            v-if="$v.form.id_number.$error"
            class="text-red-600 text-md font-medium w-full text-right"
          >
            يجب ان يتكون الرقم الوطني من 12 رقم
          </p>
        </div>
        <div
          v-if="form.nationality == 'Libyan'"
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="identity_number"
            class="font-medium text-lg w-full text-right flex items-center"
            ><span class="text-red-600 mx-2 text-3xl mt-2">*</span>رقم البطاقة
            او الجواز</label
          >
          <div class="w-full lg:pl-3 flex flex-wrap">
            <input
              id="identity_number"
              name="identity_number"
              v-model="form.identity_number"
              type="text"
              required
              @blur="$v.form.identity_number.$touch()"
              :class="
                defualtInput +
                ($v.form.identity_number.$error
                  ? ' border-red-700'
                  : 'border-inputBorder')
              "
            />
            <div class="w-full flex items-center flex-wrap mt-1">
              <label class="inline-flex items-center mx-2">
                <input
                  type="radio"
                  class="form-radio"
                  name="WorkType"
                  value="رقم البطاقة"
                  v-model="form.type_of_identity"
                  @blur="$v.form.type_of_identity.$touch()"
                  :class="
                    $v.form.type_of_identity.$error
                      ? ' border-red-700'
                      : 'border-inputBorder'
                  "
                />
                <span class="mr-2 text-h1Text">رقم البطاقة</span>
              </label>
              <label class="inline-flex items-center mx-2">
                <input
                  type="radio"
                  class="form-radio"
                  name="WorkType"
                  value="رقم الجواز"
                  v-model="form.type_of_identity"
                  @blur="$v.form.type_of_identity.$touch()"
                  :class="
                    $v.form.type_of_identity.$error
                      ? ' border-red-700'
                      : 'border-inputBorder'
                  "
                />
                <span class="mr-2 text-h1Text">رقم الجواز</span>
              </label>
            </div>
          </div>
          <p
            v-if="$v.form.identity_number.$error"
            class="text-red-600 text-sm my-1 w-full"
          >
            الرجاء تعبئة هذا الحقل
          </p>
        </div>
        <div
          v-if="form.nationality != 'Libyan'"
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="passport_copy"
            class="font-medium text-lg w-full text-right flex items-center"
            ><span class="text-red-600 mx-2 text-3xl mt-2">*</span>صورة من جواز
            السفر</label
          >
          <input
            class="hidden"
            ref="passport_copy"
            id="passport_copy"
            name="passport_copy"
            accept="image/*,.pdf"
            @change="passport_copyFunc"
            type="file"
            required
          />
          <div class="w-full flex items-center relative">
            <button
              @click="pickpassport_copyFunc"
              class="
                bg-primary
                rounded-r-md
                focus:outline-none
                absolute
                p-2
                z-20
                text-white
              "
            >
              اختر ملف
            </button>
            <input
              @click="pickpassport_copyFunc"
              type="text"
              @blur="$v.form.passport_copy.$touch()"
              :class="
                defualtInput +
                ($v.form.passport_copy.$error
                  ? ' border-red-700'
                  : 'border-inputBorder')
              "
              placeholder="لم يتم اختيار ملف"
              class="pr-20"
              :value="
                form.passport_copy
                  ? form.passport_copy.name || form.passport_copy
                  : null
              "
            />
          </div>
          <p
            v-if="$v.form.passport_copy.$error"
            class="text-red-600 text-sm my-1 w-full"
          >
            الرجاء تعبئة هذا الحقل
          </p>
        </div>

        <div
          v-if="form.nationality != 'Libyan'"
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="residency_photo"
            class="font-medium text-lg w-full text-right flex items-center"
            ><span class="text-red-600 mx-2 text-3xl mt-2">*</span
            >الاقامة</label
          >
          <input
            class="hidden"
            ref="residency_photo"
            id="residency_photo"
            name="residency_photo"
            accept="image/*,.pdf"
            @change="residency_photoFunc"
            type="file"
            required
          />
          <div class="w-full flex items-center relative">
            <button
              @click="pickresidency_photoFunc"
              class="
                bg-primary
                rounded-r-md
                focus:outline-none
                absolute
                p-2
                z-20
                text-white
              "
            >
              اختر ملف
            </button>
            <input
              @click="pickresidency_photoFunc"
              type="text"
              @blur="$v.form.residency_photo.$touch()"
              :class="
                defualtInput +
                ($v.form.residency_photo.$error
                  ? ' border-red-700'
                  : 'border-inputBorder')
              "
              placeholder="لم يتم اختيار ملف"
              class="pr-20"
              :value="
                form.residency_photo
                  ? form.residency_photo.name || form.residency_photo
                  : null
              "
            />
          </div>
          <p
            v-if="$v.form.residency_photo.$error"
            class="text-red-600 text-sm my-1 w-full"
          >
            الرجاء تعبئة هذا الحقل
          </p>
        </div>

        <div
          v-if="Branches"
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="branch_id"
            class="font-medium text-lg w-full text-right flex items-center"
            ><span class="text-red-600 mx-2 text-3xl mt-2">*</span>فرع
            النقابة</label
          >
          <v-select
            :options="Branches"
            label="name_ar"
            dir="rtl"
            id="branch_id"
            :clearable="false"
            @blur="$v.form.branch_id.$touch()"
            name="branch_id"
            v-model="form.branch_id"
            :reduce="(branch_id) => branch_id.id"
            :class="
              defualtInput +
              ($v.form.branch_id.$error
                ? ' border-red-700'
                : 'border-inputBorder')
            "
            class="p-0"
          ></v-select>
          <p
            v-if="$v.form.branch_id.$error"
            class="text-red-600 text-sm my-1 w-full"
          >
            الرجاء تعبئة هذا الحقل
          </p>
        </div>
        <div
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="marital_status"
            class="font-medium text-lg w-full text-right flex items-center"
            ><span class="text-red-600 mx-2 text-3xl mt-2">*</span>الحالة
            الاجتماعية</label
          >
          <v-select
            :options="['اعزب', 'متزوج', 'مطلق', 'ارمل']"
            id="marital_status"
            dir="rtl"
            :clearable="false"
            @blur="$v.form.marital_status.$touch()"
            name="marital_status"
            v-model="form.marital_status"
            :class="
              defualtInput +
              ($v.form.marital_status.$error
                ? ' border-red-700'
                : 'border-inputBorder')
            "
            class="p-0"
          ></v-select>
          <p
            v-if="$v.form.marital_status.$error"
            class="text-red-600 text-sm my-1 w-full"
          >
            الرجاء تحديد حالتك الاجتماعية
          </p>
        </div>
        <div
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="birth_date"
            class="font-medium text-lg w-full text-right flex items-center"
            ><span class="text-red-600 mx-2 text-3xl mt-2">*</span>تاريخ
            الميلاد</label
          >
          <input
            id="birth_date"
            name="birth_date"
            v-model="form.birth_date"
            @blur="$v.form.birth_date.$touch()"
            :max="maxDate"
            :class="
              defualtInput +
              ($v.form.birth_date.$error
                ? ' border-red-700'
                : 'border-inputBorder')
            "
            type="date"
          />
          <p
            v-if="$v.form.birth_date.$error"
            class="text-red-600 text-sm my-1 w-full"
          >
            الرجاء تعبئة هذا الحقل
          </p>
        </div>
        <div
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="address"
            class="font-medium text-lg w-full text-right flex items-center"
            ><span class="text-red-600 mx-2 text-3xl mt-2">*</span>عنوان
            السكن</label
          >
          <input
            id="address"
            name="address"
            v-model="form.address"
            type="text"
            required
            @blur="$v.form.address.$touch()"
            :class="
              defualtInput +
              ($v.form.address.$error
                ? ' border-red-700'
                : 'border-inputBorder')
            "
          />
          <p
            v-if="$v.form.address.$error"
            class="text-red-600 text-sm my-1 w-full"
          >
            الرجاء تعبئة هذا الحقل
          </p>
        </div>
        <div
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label for="email" class="font-medium text-lg w-full text-right"
            >البريد الالكتروني</label
          >
          <input
            id="email"
            name="email"
            v-model="form.email"
            type="email"
            required
            :class="defualtInput + 'border-inputBorder'"
          />
        </div>
        <div
          class="p-5 flex items-center justify-center w-full md:w-1/2 flex-wrap"
        >
          <label
            for="phone_number"
            class="font-medium text-lg w-full text-right flex items-center"
            ><span class="text-red-600 mx-2 text-3xl mt-2">*</span>رقم
            الهاتف</label
          >
          <input
            id="phone_number"
            name="phone_number"
            v-model="form.phone_number"
            type="tel"
            required
            @blur="$v.form.phone_number.$touch()"
            :class="
              defualtInput +
              ($v.form.phone_number.$error
                ? ' border-red-700'
                : 'border-inputBorder')
            "
          />
          <p
            v-if="$v.form.phone_number.$error && !$v.form.phone_number.required"
            class="text-red-600 text-md font-medium w-full text-right"
          >
            الرجاء كتابة رقم الهاتف
          </p>
          <p
            v-if="!$v.form.phone_number.minLength"
            class="text-red-600 text-md font-medium w-full text-right"
          >
            الرجاء التحقق من صحة رقم الهاتف، رقم الهاتف يجب ن يكون على النحو
            التالي 09xxxxxxxx
          </p>
        </div>
      </div>
    </div>
    <div class="flex w-full lg:w-3/4 mx-auto items-center justify-end">
      <p v-if="$v.form.$error" class="text-red-600 text-md font-medium">
        الرجاء تكملة الحقول المطلوبة
      </p>
      <button
        @click="
          clear;
          $router.go(-1);
        "
        class="
          px-8
          rounded-md
          w-auto
          shadow
          py-2
          focus:outline-none
          hover:shadow-lg
          m-3
          md:m-5
          border border-primary
          text-primary
          bg-white
          text-lg
          font-medium
        "
      >
        رجوع
      </button>
      <button
        :disabled="$v.form.$error"
        @click.prevent="next"
        class="
          px-8
          rounded-md
          w-auto
          shadow
          py-2
          focus:outline-none
          hover:shadow-lg
          m-3
          md:m-5
          bg-primary
          text-white text-lg
          font-medium
        "
      >
        التالي
      </button>
    </div>
  </div>
</template>
<script>
import {
  required,
  numeric,
  minLength,
  email,
  maxLength,
} from "vuelidate/lib/validators";
import moment from "moment";
import nationalities from "../../../assets/nationalities.js";
export default {
  name: "individualGeneralInfo",
  data() {
    return {
      nationalities: nationalities,
      url: process.env.VUE_APP_URL,
      defualtInput:
        "p-2  bg-white rounded-md border w-full text-right focus-within:border-primary hover:border-primary focus:border-primary focus:outline-none focus:shadow-md my-1",
      maxDate: moment().format("L"),
      imageSrc: null,
      SearchText: "",
      isHonoraryMembership: false,
      form: {
        doctor_image: "",
        name: "",
        member_ship_id: "",
        birth_date: "",
        id_number: "",
        type_of_identity: "",
        identity_number: "",
        marital_status: "",
        address: "",
        email: "",
        phone_number: "",
        branch_id: "",
        nationality: "Libyan",
        passport_copy: "",
        residency_photo: "",
      },
      memeberShipExsistError: "",
    };
  },
  validations() {
    if (this.form.nationality == "Libyan") {
      return {
        form: {
          branch_id: { required },
          name: { required },
          nationality: { required },
          birth_date: { required },
          email: { email },
          id_number: {
            required,
            numeric,
            minLength: minLength(12),
            maxLength: maxLength(12),
          },
          marital_status: { required },
          address: { required },
          phone_number: { required, minLength: minLength(10) },
          type_of_identity: { required },
          identity_number: { required },
        },
      };
    } else if (this.form.nationality != "Libyan") {
      return {
        form: {
          branch_id: { required },
          name: { required },
          nationality: { required },
          birth_date: { required },
          email: { email },
          marital_status: { required },
          address: { required },
          phone_number: { required, minLength: minLength(10) },
          passport_copy: { required },
          residency_photo: { required },
        },
      };
    }
  },
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    Branches() {
      return this.$store.getters.getBranches;
    },
    editDoctor() {
      return this.$store.getters.editDoctor;
    },
    individualData() {
      return this.$store.getters.individualData;
    },
    SavedImageSrc() {
      return this.$store.getters.SavedImageSrc;
    },
  },
  mounted() {
    if (this.editDoctor) {
      this.isHonoraryMembership =
        this.editDoctor.member_ship_id == null ? true : false; // if it was null then it means that he has no membership which is a honorary membership
      this.form = {
        doctor_image:
          this.editDoctor.photos.length > 0
            ? this.editDoctor.photos.find((img) => (img.name = "doctor_image"))
                .path
            : "",
        name: this.editDoctor.name,
        birth_date: this.editDoctor.birth_date,
        member_ship_id: `${this.editDoctor.member_ship_id}`,
        id_number: this.editDoctor.id_number,
        type_of_identity: this.editDoctor.type_of_identity,
        identity_number: this.editDoctor.identity_number,
        marital_status: this.editDoctor.marital_status,
        address: this.editDoctor.address,
        email: this.editDoctor.email,
        phone_number: this.editDoctor.phone_number,
        branch_id: this.editDoctor.branch_id,
        nationality: this.editDoctor.nationality,
        passport_copy:
          this.editDoctor.photos.passport_copy.length > 0
            ? this.editDoctor.photos.passport_copy.path
            : "",
        residency_photo:
          this.editDoctor.photos.residency_photo.length > 0
            ? this.editDoctor.photos.residency_photo.path
            : "",
      };
      if (this.editDoctor.doctor_image) {
        this.imageSrc = this.url + this.editDoctor.doctor_image;
      }
    }
  },
  created() {
    this.$store.dispatch("getBranches");
    if (this.individualData) {
      this.form = { ...this.form, ...this.individualData };
    }
    if (this.SavedImageSrc) {
      this.imageSrc = this.SavedImageSrc;
    }
    window.onpopstate = () => {
      if (
        this.$route.name == "Dashboard" ||
        this.$route.name == "DoctorsPanel"
      ) {
        this.clear();
      }
    };
    if (this.userData) {
      if (this.userData.status !== "super-admin") {
        this.form.branch_id = this.userData.branch_id;
      }
    }
  },
  methods: {
    async handleMemberShipIdBlur(e) {
      try {
        await this.$axios.post("/api/doctors/search", {
          member_ship_id: e.target.value,
        });
        this.memeberShipExsistError = "";
      } catch (err) {
        if (err.response.status == 409) {
          this.memeberShipExsistError = "رقم العضوية موجود مسبقا";
        }
      }
    },
    clear() {
      this.$store.commit("editDoctor", null);
      this.$store.commit("SavedImageSrc", null);
      this.imageSrc = null;
      this.$store.commit("individualFormFilling", null);
    },
    pickPicture() {
      this.$refs.uploadImg.click();
    },
    OnPickerChange(e) {
      if (!e.target.files.length) return;
      this.form.doctor_image = e.target.files[0];
      this.imageSrc = URL.createObjectURL(e.target.files[0]);
    },
    pickpassport_copyFunc() {
      this.$refs.passport_copy.click();
    },
    pickresidency_photoFunc() {
      this.$refs.residency_photo.click();
    },
    passport_copyFunc(e) {
      if (!e.target.files.length) return;

      const file = e.target.files[0].type;
      if (
        file == "image/png" ||
        file == "application/pdf" ||
        file == "image/jpeg" ||
        file == "image/jpg"
      ) {
        this.form.passport_copy = e.target.files[0];
      } else {
        let message = [
          " هذا الملف غير صالح ، الرجاء تحميل الملف بصغة pdf او صورة",
        ];
        this.$store.commit("toggleErrorMsg", message);
      }
    },
    residency_photoFunc(e) {
      if (!e.target.files.length) return;
      const file = e.target.files[0].type;
      if (
        file == "image/png" ||
        file == "application/pdf" ||
        file == "image/jpeg" ||
        file == "image/jpg"
      ) {
        this.form.residency_photo = e.target.files[0];
      } else {
        let message = [
          " هذا الملف غير صالح ، الرجاء تحميل الملف بصغة pdf او صورة",
        ];
        this.$store.commit("toggleErrorMsg", message);
      }
    },
    next() {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;
      if (typeof this.form.doctor_image == "string") {
        delete this.form.doctor_image;
      }
      if (typeof this.form.passport_copy == "string") {
        delete this.form.passport_copy;
      }
      if (typeof this.form.residency_photo == "string") {
        delete this.form.residency_photo;
      }

      this.$store.commit("individualFormFilling", {
        ...this.form,
        member_ship_id: this.isHonoraryMembership
          ? "بلا"
          : this.form.member_ship_id,
      });
      this.$store.commit("SavedImageSrc", this.imageSrc);
      this.$router.push({ name: "Education" });
    },
  },
};
</script>
